import { Navigate } from "react-router-dom";

// Old marketing demo form is now superseded by the real tenant registration.
// Redirect any legacy traffic to the real signup flow.
export default function GetStarted() {
  return <Navigate to="/register" replace />;
}
